// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.7) 0%, rgba(10, 42, 48, 0.8) 100%);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .wallet-modal-content {
    background-color: var(--bg-white);
    border-radius: 20px;
    width: 100%;
    max-width: 440px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 12px 40px rgba(17, 69, 77, 0.3);
    animation: slideUp 0.3s ease;
  }

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .wallet-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 2px solid var(--border-gray);
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.03) 0%, rgba(95, 184, 165, 0.03) 100%);
  }

  .wallet-modal-header h3 {
    margin: 0;
    color: var(--primary-teal);
    font-size: 1.4rem;
    font-weight: 600;
  }

  .wallet-modal-close {
    background: none;
    border: none;
    font-size: 28px;
    color: var(--text-medium);
    cursor: pointer;
    padding: 0;
    margin: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
  }

  .wallet-modal-close:hover {
    background-color: rgba(17, 69, 77, 0.08);
    color: var(--primary-teal);
    transform: rotate(90deg);
  }

  .wallet-modal-body {
    padding: 24px;
  }

  .wallet-list-section {
    margin-bottom: 28px;
  }

  .wallet-list-section h4 {
    font-size: 1.05rem;
    color: var(--primary-teal);
    margin-bottom: 14px;
    font-weight: 600;
  }

  .wallet-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .wallet-list-item {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid transparent;
  }

  .wallet-list-item:hover {
    background: linear-gradient(90deg, rgba(17, 69, 77, 0.04) 0%, rgba(95, 184, 165, 0.04) 100%);
    border-color: var(--primary-teal-light);
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(17, 69, 77, 0.1);
  }

  .wallet-list-item img {
    width: 36px;
    height: 36px;
    margin-right: 14px;
    object-fit: contain;
    border-radius: 8px;
  }

  .wallet-list-item span {
    font-weight: 500;
    color: var(--text-dark);
    font-size: 0.98rem;
  }

  .wallet-none-message {
    color: var(--text-light);
    font-style: italic;
    padding: 12px 0;
    text-align: center;
  }

  .wallet-modal-footer {
    padding: 20px 24px;
    border-top: 2px solid var(--border-gray);
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);
  }

  .wallet-modal-note {
    font-size: 0.85rem;
    color: var(--text-medium);
    margin: 0;
    line-height: 1.5;
  }`, "",{"version":3,"sources":["webpack://./src/components/WalletModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yFAAyF;IACzF,0BAA0B;IAC1B,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;EACnB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,6CAA6C;IAC7C,4BAA4B;EAC9B;;EAEA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;IAC3C,6FAA6F;EAC/F;;EAEA;IACE,SAAS;IACT,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,wCAAwC;IACxC,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,4FAA4F;IAC5F,uCAAuC;IACvC,0BAA0B;IAC1B,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,wCAAwC;IACxC,6FAA6F;EAC/F;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,gBAAgB;EAClB","sourcesContent":[".wallet-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.7) 0%, rgba(10, 42, 48, 0.8) 100%);\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    animation: fadeIn 0.3s ease;\n  }\n\n  @keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n\n  .wallet-modal-content {\n    background-color: var(--bg-white);\n    border-radius: 20px;\n    width: 100%;\n    max-width: 440px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 12px 40px rgba(17, 69, 77, 0.3);\n    animation: slideUp 0.3s ease;\n  }\n\n  @keyframes slideUp {\n    from {\n      transform: translateY(20px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n\n  .wallet-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n    border-bottom: 2px solid var(--border-gray);\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.03) 0%, rgba(95, 184, 165, 0.03) 100%);\n  }\n\n  .wallet-modal-header h3 {\n    margin: 0;\n    color: var(--primary-teal);\n    font-size: 1.4rem;\n    font-weight: 600;\n  }\n\n  .wallet-modal-close {\n    background: none;\n    border: none;\n    font-size: 28px;\n    color: var(--text-medium);\n    cursor: pointer;\n    padding: 0;\n    margin: 0;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: all 0.3s ease;\n  }\n\n  .wallet-modal-close:hover {\n    background-color: rgba(17, 69, 77, 0.08);\n    color: var(--primary-teal);\n    transform: rotate(90deg);\n  }\n\n  .wallet-modal-body {\n    padding: 24px;\n  }\n\n  .wallet-list-section {\n    margin-bottom: 28px;\n  }\n\n  .wallet-list-section h4 {\n    font-size: 1.05rem;\n    color: var(--primary-teal);\n    margin-bottom: 14px;\n    font-weight: 600;\n  }\n\n  .wallet-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n\n  .wallet-list-item {\n    display: flex;\n    align-items: center;\n    padding: 14px 16px;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border: 1px solid transparent;\n  }\n\n  .wallet-list-item:hover {\n    background: linear-gradient(90deg, rgba(17, 69, 77, 0.04) 0%, rgba(95, 184, 165, 0.04) 100%);\n    border-color: var(--primary-teal-light);\n    transform: translateX(4px);\n    box-shadow: 0 2px 8px rgba(17, 69, 77, 0.1);\n  }\n\n  .wallet-list-item img {\n    width: 36px;\n    height: 36px;\n    margin-right: 14px;\n    object-fit: contain;\n    border-radius: 8px;\n  }\n\n  .wallet-list-item span {\n    font-weight: 500;\n    color: var(--text-dark);\n    font-size: 0.98rem;\n  }\n\n  .wallet-none-message {\n    color: var(--text-light);\n    font-style: italic;\n    padding: 12px 0;\n    text-align: center;\n  }\n\n  .wallet-modal-footer {\n    padding: 20px 24px;\n    border-top: 2px solid var(--border-gray);\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);\n  }\n\n  .wallet-modal-note {\n    font-size: 0.85rem;\n    color: var(--text-medium);\n    margin: 0;\n    line-height: 1.5;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
